import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return {
      id: data.id,
      name: `${data.vaxiom_person.first_name} ${data.vaxiom_person.last_name}`,
    }
  }, [data])
}
